import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/context/LanguageContext";
import type { HelpDialogProps } from "@/types/recording";
import { ChromeTabPickerPreview } from "./ChromeTabPickerPreview";

export function HelpDialog({ open, onOpenChange }: HelpDialogProps) {
  const { t } = useTranslation();
  const steps = [
    t("recording.help.step1"),
    t("recording.help.step2"),
    t("recording.help.step3"),
    t("recording.help.step4"),
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{t("recording.help.title")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("recording.help.title")}
          </DialogDescription>
        </DialogHeader>

        <ol className="flex flex-col gap-3 pt-1">
          {steps.map((step, i) => (
            <li key={i} className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-foreground text-xs font-semibold text-background">
                {i + 1}
              </span>
              <span className="text-sm text-foreground">{step}</span>
            </li>
          ))}
        </ol>

        <div className="pt-2">
          <ChromeTabPickerPreview />
        </div>

        <DialogFooter>
          <Button
            onClick={() => onOpenChange(false)}
            className="rounded-xl bg-foreground text-background hover:bg-foreground/90"
          >
            {t("recording.help.cta")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
